import React from "react";
import ProductCard from "./ProductCard";
import { useSelector } from "react-redux";
import { getProfile } from "../../reduxenv/Slices/ProfileSlice";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { AppColors } from "../../common/AppColors";
import { ProductsLoader } from "../Loaders/ProductsLoader";
import { ServerProductModel } from "../../models/ServerProductModel";
import ServerProductCard from "./ServerProductCard";

interface Props {
  title: string;
  productList: ServerProductModel[];
  isFetching: boolean;
  error: any;
  slidesPerRow: number;
  rows: number;
  enableNoProductsMessage?: boolean;
}

const ServerProductsSlider: React.FC<Props> = (props) => {
  const profile = useSelector(getProfile);
  let productList = props.productList;

  return (
    <Box overflow={"hidden"} pb={4}>
      <Typography color={AppColors.Blue} variant="h5" mb={2}>
        {props.title}
      </Typography>
      {props.isFetching ? (
        <ProductsLoader />
      ) : productList && productList.length > 0 ? (
        productList.map((product, index) => (
          <ServerProductCard
            key={index}
            product={product}
            currency={profile.country.currency}
          />
        ))
      ) : (
        props.enableNoProductsMessage && (
          <Typography
            variant="subtitle1"
            color={AppColors.MainColor}
            sx={{
              textAlign: "center",
              bgcolor: AppColors.LightColor,
              p: 4,
              borderRadius: "8px",
              mt: { xs: "5vh", lg: "6vh" },
              mb: { xs: "5vh", lg: "6vh" },
              maxWidth: "400px",
              margin: "auto",
            }}
          >
            No products found!
          </Typography>
        )
      )}
    </Box>
  );
};

export default ServerProductsSlider;
